import { useState } from "react";
import { LuCheck, LuRotateCcw, LuTrash2 } from "react-icons/lu";
import * as styled from "./VocabularyTable.styled";

const FILTERS = [
  { value: "all", label: "Усі" },
  { value: "new", label: "Нові" },
  { value: "learned", label: "Вивчені" },
];

function VocabularyTable({ words, onDelete, onToggleLearned }) {
  const [filter, setFilter] = useState("all");

  // Спочатку нові (найсвіжіші зверху), вивчені — вниз
  const sortedWords = [...words].sort((a, b) => {
    if (a.isLearned === b.isLearned) {
      return new Date(b.createdAt) - new Date(a.createdAt);
    }
    return a.isLearned ? 1 : -1;
  });

  const learnedCount = words.filter((w) => w.isLearned).length;
  const counts = { all: words.length, new: words.length - learnedCount, learned: learnedCount };
  const visible = sortedWords.filter((w) =>
    filter === "all" ? true : filter === "learned" ? w.isLearned : !w.isLearned
  );

  const handleDelete = (word) => {
    if (window.confirm(`Видалити слово «${word.word}»?`)) onDelete(word._id);
  };

  if (words.length === 0) {
    return <styled.Empty>Тут з'являться слова, які ти додаси або які додасть вчитель.</styled.Empty>;
  }

  return (
    <styled.Wrapper>
      <styled.Filters>
        {FILTERS.map(({ value, label }) => (
          <styled.Filter key={value} $active={filter === value} onClick={() => setFilter(value)}>
            {label} <span>{counts[value]}</span>
          </styled.Filter>
        ))}
      </styled.Filters>

      <styled.List>
        {visible.map((word) => (
          <styled.TableRow key={word._id} $learned={word.isLearned}>
            <styled.Words>
              <styled.Word>{word.word}</styled.Word>
              <styled.Translation>{word.translation}</styled.Translation>
            </styled.Words>

            <styled.StatusLabel $learned={word.isLearned}>
              {word.isLearned ? "Вивчено" : "Нове"}
            </styled.StatusLabel>

            <styled.ActionGroup>
              <styled.ActionButton
                onClick={() => onToggleLearned(word._id)}
                $variant={word.isLearned ? "new" : "learned"}
                title={word.isLearned ? "Повернути в нові" : "Позначити вивченим"}
                aria-label={word.isLearned ? "Повернути в нові" : "Позначити вивченим"}
              >
                {word.isLearned ? <LuRotateCcw size={18} /> : <LuCheck size={18} />}
              </styled.ActionButton>
              <styled.ActionButton
                onClick={() => handleDelete(word)}
                $variant="delete"
                title="Видалити"
                aria-label="Видалити"
              >
                <LuTrash2 size={18} />
              </styled.ActionButton>
            </styled.ActionGroup>
          </styled.TableRow>
        ))}
      </styled.List>
    </styled.Wrapper>
  );
}

export default VocabularyTable;
